import { render, staticRenderFns } from "./NewListGroupModal.vue?vue&type=template&id=1e977139&scoped=true&"
import script from "./NewListGroupModal.vue?vue&type=script&lang=js&"
export * from "./NewListGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./NewListGroupModal.vue?vue&type=style&index=0&id=1e977139&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e977139",
  null
  
)

export default component.exports